import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  constructor(private controlName: string) {}

  /** Check for reference equality between the two values */
  confirmEqual = (control: AbstractControl) => {
    return this.compare(control, other => other.value.toLowerCase() === control.value.toLowerCase());
  }


  confirmEmailMatch = (control: AbstractControl) => {
    const email = control.root.get(this.controlName)?.value;
    if(email)
      return this.compare(control, other => other.value.toLowerCase() === control.value.toLowerCase());
    else{
      return { notMatch: true };
    }
  }

  /** Check that the E-164 values of the two numbers are equal */
  confirmPhoneMatch = (control: AbstractControl) => {
    return this.compare(control, phone =>
      phone.value?.e164Number === control.value?.e164Number
    );
  }

  maxSelection(max: number): ValidatorFn {
    return (control: AbstractControl) => {
      const numberOfSelections = control.value.length;
      if (isNaN(numberOfSelections) || numberOfSelections > max){
        return {
           maxSelection: true
        };
      }
      return null;
    };
  }

  private compare(control: AbstractControl, compare: (other: AbstractControl) => boolean)  {
    if (control && (control.value !== null && control.value !== undefined)) {
      const other = control.root.get(this.controlName);
      if (other && !compare(other)) {
        return { notMatch: true };
      }
    }
    return null;
  }
}

export function confirmMatchField(fieldName: string): ValidatorFn {
  return (control: AbstractControl) => {
    const mainControl = control.get(fieldName);
    const confirmControl = control.get('confirm');
    if (!mainControl) {
      throw new Error(`cannot confirm match; control has no child named '${fieldName}'`);
    } else if (!confirmControl) {
      throw new Error('cannot confirm match; control has no child named \'confirm\'');
    }
    return mainControl.value === confirmControl.value ?
      null : { mismatch: true };
  };
}
